import { PageTitleWithPageNumber } from "$components/page/page-title-with-page-number";
import { useConfig } from "$global-providers/config-provider/provider";
import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";
import { useIntl } from "react-intl";

const NewTitle: FC<{ pageNumber: number }> = ({ pageNumber }) => {
  const { formatMessage } = useIntl();
  const { territory } = useConfig();
  const [patientPayEnabled] = useFeatureFlag(featureFlags.patientPay);
  const title = formatMessage({
    id: "registration.layout.title",
    defaultMessage: "Add New Patient",
  });

  const denominator = (() => {
    let result = territory === TERRITORY.PAKISTAN ? 1 : 2;
    if (patientPayEnabled) {
      // We will be showing the payment page
      result += 1;
    }
    return result;
  })();

  return (
    <PageTitleWithPageNumber
      title={title}
      pageNumberNumerator={pageNumber}
      pageNumberDenominator={denominator}
    />
  );
};

export default NewTitle;
